@if (elevation && (currentUser$ | async); as user) {
  <div class="container">
    <!------- Header ------->
    <div class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        <div class="info">
          <div class="title">{{elevation.name}}</div>
          <div class="sub-title">{{elevation.center | wgs84}}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'expand' | transloco}}"
            (click)="onClickExpand()">expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'collapse' | transloco}}"
            (click)="onClickCollapse()">collapse_content
          </button>
        }
        <button mat-icon-button
          matTooltip="{{'close' | transloco}}"
          (click)="onClickClose()">close
        </button>
      </div>
    </div>
    <!------- Content ------->
    <div class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">
        <elevation-chart #graph
          class="chart"
        [ngClass]="(isExpanded$ | async) ? 'chart-expanded' : 'chart-collapsed'"> </elevation-chart>
        <!------- Actions ------->
        <div class="actions">
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              matTooltip="{{'move_the_camera_on_the_elevation' | transloco}}"
              class="material-symbols-outlined"
              (click)="onClickFlyTo(elevation)">my_location
            </button>
          }
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              [matTooltip]="(elevation.show ? 'hide_overlay' : 'show_overlay') | transloco"
              [disabled]="!(displayElevations$ | async)"
              (click)="onClickToggleShow(elevation)">
              <mat-icon>
                {{ elevation.show ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          }
          @if (user.name == elevation.author) {
            <button
              mat-icon-button
              matTooltip="{{'rename' | transloco}}"
              (click)="onClickRename(elevation)"><mat-icon>edit</mat-icon></button>
            }
            @if (!elevation.isShared && user.name == elevation.author) {
              <button
                mat-icon-button
                matTooltip="{{'share' | transloco}}"
                (click)="onClickToggleShare(elevation)">
                <mat-icon>share</mat-icon>
              </button>
            }
            @if (elevation.isShared && user.name == elevation.author) {
              <button
                mat-icon-button
                matTooltip="{{'share_off' | transloco}}"
                (click)="onClickToggleShare(elevation)">
                <mat-icon>share_off</mat-icon>
              </button>
            }
            <span class="spacer"></span>
            @if (user.name == elevation.author) {
              <button
                style="color: var(--warn-color)"
                mat-icon-button
                matTooltip="{{'delete' | transloco}}"
                (click)="onClickDelete(elevation)">delete
              </button>
            }
          </div>
        </div>
        <div class="side"
          [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
          <!------- Author ------->
          <!--      <div *ngIf="user.name != elevation.author" class="author">{{'created_by_f' | transloco }} {{elevation.author}}</div>-->
          <!------- History ------->
          <tracker-history-channel class="history" [itemId]="elevation.id"></tracker-history-channel>
        </div>
      </div>
    </div>
  }
